// extracted by mini-css-extract-plugin
export default {"heading":"Exercises_heading__dHbcM","ul":"Exercises_ul__kqXpT","li":"Exercises_li__3WhzL","container":"Exercises_container__p3vDV"};